import React from 'react'
import clsx from 'clsx'

import { useLayoutContentStyles } from './layout-content.styles'

export type ContentProps = {
  children: React.ReactNode
  withSidebar?: boolean
}

export const LayoutContent: React.FC<ContentProps> = (props) => {
  const classes = useLayoutContentStyles()

  return (
    <div
      className={clsx(classes.content, {
        [classes.withSidebar]: props.withSidebar
      })}
    >
      {props.children}
    </div>
  )
}
